module.exports = __webpack_public_path__ + "media/images/motto-bg1-99e8b11bce5042e1ab30029f11f68a9d.png";